import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

export interface IConsumerChargingSelectItem {
    Id: string;
    IdWallet: string;
    Name: string;
    VatNumber: string;
    WalletSynchronized: boolean;
    IdentificationDocumentNumber: string;
    Checked: boolean;
}

@Component({
    selector: 'app-select-consumer-charging',
    templateUrl: './select-consumer-charging.component.html',
    styleUrls: ['./select-consumer-charging.component.scss'],
})
export class SelectConsumerChargingModalComponent implements OnInit {

    public Data: IConsumerChargingSelectItem[] = [];
    public FilteredData: IConsumerChargingSelectItem[] = [];
    public SearchText: string = '';
    public AllChecked: boolean = false;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController) {

        this.Data = this.NavParams.get('data') || [];
        this.FilteredData = [...this.Data];
        this.AllChecked = this.Data.length > 0 && this.Data.every(it => it.Checked);
    }

    ngOnInit() { }

    OnSearch(value: string) {
        this.SearchText = (value || '').toLowerCase();
        this.FilteredData = this.SearchText
            ? this.Data.filter(it =>
                it.Name?.toLowerCase().includes(this.SearchText) ||
                it.VatNumber?.toLowerCase().includes(this.SearchText)
            )
            : [...this.Data];
    }

    OnChangeValue(ev: any, item: IConsumerChargingSelectItem | null, all: boolean = false) {
        ev?.preventDefault();
        ev?.stopPropagation();

        const isChecked = all ? !this.AllChecked : ev?.detail?.checked;

        if (all) {
            this.Data.forEach(d => d.Checked = isChecked);
            this.FilteredData.forEach(d => d.Checked = isChecked);
            this.AllChecked = isChecked;
        } else if (item) {
            const found = this.Data.find(d => d.IdWallet?.toLowerCase() === item.IdWallet?.toLowerCase());
            if (found && found.Checked !== isChecked) {
                found.Checked = isChecked;
            }
            this.AllChecked = this.Data.length > 0 && this.Data.every(it => it.Checked);
        } else {
            this.AllChecked = this.Data.length > 0 && this.Data.every(it => it.Checked);
        }
    }

    OnSave(ev: any) {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.ModalController.dismiss(this.Data.filter(it => it.Checked), EnumGenericRoleActionAlerts.Save);
    }

    Close() {
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }
}
